import { NOTES_DEMO_CONTENT } from './notesDemoContent'
import { noteAt, withContent } from './notesRailDemoNoteUtils'

/** @type {import('../lib/types.js').NotesRailNoteWire[]} */
export const notesRailDemoRegularNotesB = [
  withContent({
    id: 'n-myman-scratch',
    kind: 'note',
    title: 'Quick scratch — Myman',
    authorName: 'Myman',
    content: NOTES_DEMO_CONTENT.mymanScratch,
    at: noteAt(0, 18, 45),
  }),
  withContent({
    id: 'n-research',
    kind: 'note',
    title: 'User research — notes rail',
    authorName: 'Sam Patel',
    content: NOTES_DEMO_CONTENT.research,
    at: noteAt(4, 11, 0),
  }),
  withContent({
    id: 'n-launch-checklist',
    kind: 'note',
    title: 'Launch checklist — Mission Control',
    authorName: 'You',
    content: NOTES_DEMO_CONTENT.launchChecklist,
    at: noteAt(12, 9, 30),
  }),
]
